import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { IBrilliantSwitch } from "../../interfaces/interfaces";
import { GET_SWITCH_DETAILS } from "../../api/gqlQueries";
import { ReactComponent as Switch } from "../../img/Devices/Switch.svg";
import Spinner from "../Spinner";
import { getReadableTime } from "../../utils/utils";

export interface ISwitchDetailsProps {
  deviceId: string;
  propertyId: string;
  setDeviceName: (name: string) => void;
}

const SwitchDetails: React.FC<ISwitchDetailsProps> = ({
  deviceId,
  propertyId,
  setDeviceName,
}) => {
  const { data, loading } = useQuery<IBrilliantSwitch>(GET_SWITCH_DETAILS, {
    variables: { deviceId, propertyId },
  });
  useEffect(() => {
    setDeviceName(data?.brilliantSwitch.name || "");
  }, [data]);
  if (loading) return <Spinner />;
  if (!data) return <div>No data was returned</div>;
  return (
    <>
      <div className="device-details-container">
        <div className="device-details-container-header">
          <div className="device-details-container-left">
            <Switch
              title="Smart Dimmer Switch"
              className="brilliant-card-img-left brilliant-card-img-left-stroke"
            />
            <div>
              <div className="unit-title hidden-name">
                {data.brilliantSwitch.name}
              </div>
              <div className="brilliant-card-description-type unit-description-small flex-display uppercase">
                Brilliant Dimmer Switch
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="brilliant-container-name menu">Device Information</div>
      <div className="device-details-container device-details-container-info">
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Device Name
          </div>
          <div className="tool-tip margin-bottom-small">
            {data.brilliantSwitch.name}
          </div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Assigned To
          </div>
          <div className="tool-tip">{data.brilliantSwitch.roomName}</div>
        </div>
      </div>
      <br />
      <div className="brilliant-container-name menu">Load Configuration</div>
      <div className="device-details-container device-details-container-info device-details-container-info-3">
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Load Name
          </div>
          <div className="tool-tip">{data.brilliantSwitch.load?.name}</div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Load details
          </div>
          <div className="device-details-container-info-load">
            {data.brilliantSwitch.load?.dimmable && (
              <div className="device-details-container-info-load-item tool-tip margin-right-very-small">
                Dimmable
              </div>
            )}
            {data.brilliantSwitch.load?.loadType && (
              <div className="device-details-container-info-load-item tool-tip margin-right-very-small">
                {data.brilliantSwitch.load?.loadType}
              </div>
            )}
            {data.brilliantSwitch.load?.lowWattage && (
              <div className="device-details-container-info-load-item tool-tip margin-right-very-small">
                Low Wattage
              </div>
            )}
            {data.brilliantSwitch.load?.magneticLoad && (
              <div className="device-details-container-info-load-item tool-tip margin-right-very-small">
                Magnetic Load
              </div>
            )}
            {data.brilliantSwitch.load?.multiWay && (
              <div className="device-details-container-info-load-item tool-tip">
                Multi-Way
              </div>
            )}
          </div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Assigned to
          </div>
          <div className="tool-tip">
            {data.brilliantSwitch.load?.rooms.join(", ")}
          </div>
        </div>
      </div>
      <br />
      <div className="brilliant-container-name menu">Connectivity</div>
      <div className="device-details-container device-details-container-info device-details-container-info-2">
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Last Software Update
          </div>
          <div className="tool-tip">
            {getReadableTime(data.brilliantSwitch.lastSoftwareUpdate || "")}
          </div>
        </div>
        <div>
          <div className="sub-heading inactive-font margin-bottom-small">
            Last Cloud Sync
          </div>
          <div className="tool-tip">
            {getReadableTime(data.brilliantSwitch.lastKnownCloudSync || "")}
          </div>
        </div>
      </div>
    </>
  );
};

export default SwitchDetails;
